import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Network from '../../network/index';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Typography, TextField, Button, InputAdornment, Tabs, Tab, useTheme, IconButton, Tooltip, MenuItem, Menu, CircularProgress } from '@mui/material';
import { VisibilityOutlined, VisibilityOffOutlined, SmartphoneOutlined, WarningAmber, InfoSharp, ExpandMore } from '@mui/icons-material';
import { styled } from "../../theme";
import { Card, ModalDownloadAppQR, ModalSupport } from '../ui';
import { ReactComponent as AskChatIcon  } from '../../assets/icons/icon_ask_chat.svg'
import { ReactComponent as RussiaIcon  } from '../../assets/icons/icon_ru_flag.svg'
import { ReactComponent as UzbekistanIcon  } from '../../assets/icons/icon_uz_flag.svg'
import maskPhoneInput from '../../helpers/maskPhoneInput';
import formatPhoneNumber from '../../helpers/formatPhoneNumber';
import { AppHeader } from './components';
import { sanitizePhone } from '../../helpers/sanitizePhone';


function removeCookies() {
  Cookies.remove("login");
  Cookies.remove("hash");
  Cookies.remove("server");
  Cookies.remove("token");
}

function Login () {
  const navigate = useNavigate()
  const theme = useTheme()

  const [searchParams, setSearchParams] = useSearchParams();
  const messageText = searchParams.get('message')

  // Стейты логина
  const [isLoading, setIsLoading] = useState(false);
  const [message,   setMessage]   = useState("");
  const isStop = useRef(false);

  const { notification } = useSelector(state => state.app);

  // Модальные окна
  const [modalQR, setModalQR]           = useState(false);
  const [modalSupport, setModalSupport] = useState(false);

  const [submitData, setSubmitData] = useState({ login: null, password: null })
  const [showPassword, setShowPassword] = useState(false);
  const [selectedTab, setSelectedTab] = useState('phone') 

  const [countrySelect, setCountrySelect] = useState({
    anchorEl: null,
    countryCode: 'RU',
    phoneCode: '+7',
    phoneLength: 10,
    placeholder: '+7 (_ _ _) _ _ _ - _ _ - _ _'
  })
  const openCountrySelect = Boolean(countrySelect.anchorEl);

  useEffect(() => {
    if (window.location.href.indexOf("logout") > 0) {
        removeCookies();
    } else {
        if (Cookies.get("hash") && Cookies.get("login")) {
            postCookieSignin(Cookies.get("login"), Cookies.get("hash"));
        }
    }
  }, []);


  function setOnErrorMessage(err, res) {
    if(err)     setMessage('Произошла ошибка')
    if(!res.ok) setMessage('Неправильные логин или пароль')
  }

  // Логин по куки
  const postCookieSignin = async (login, hash) => {
    if(!login || !hash) return;

    setIsLoading(true)
    setMessage('')
    isStop.current = false
    Network.postCookieSignin(JSON.stringify({ login, hash }), (err, res) => {
      setIsLoading(false)

      if(isStop.current) {
        removeCookies()
        return;
      }

      if(err || !res.ok) {
        setOnErrorMessage(err, res)
        if(!res.ok) removeCookies()
        return;
      }

      // Чистим МП токен куки, на случай если были
      Cookies.remove("server");
      Cookies.remove("token");

      // Cookies.set('hash', res.hash, { expires: 365 });
      // Cookies.set('login', res.login, { expires: 365 });
      redirect(res)
    })
  }

  // Логин по форме
  const postSignin = async (e) => {
    if (e) e.preventDefault();

    setIsLoading(true)
    setMessage('')
    isStop.current = false

    let login = selectedTab === 'phone' 
      ? sanitizePhone(submitData.login, countrySelect.phoneCode, countrySelect.countryCode) 
      : submitData.login

    Network.postSignin(JSON.stringify({ login: login, password: submitData.password }), (err, res) => {
      setIsLoading(false)

      if(isStop.current) {
        removeCookies()
        return;
      }

      if(err || !res.ok) {
        removeCookies()
        setOnErrorMessage(err, res)
        return;
      }

      // Чистим МП токен куки, на случай если были
      Cookies.remove("server");
      Cookies.remove("token");

      Cookies.set('hash', res.hash, { expires: 365 });
      Cookies.set('login', res.login, { expires: 365 });
      redirect(res)
    })
  }

  const cancelSignin = () => {
    isStop.current = true;
    setIsLoading(false);
  };

  const handleTabChange = (newValue) => {
    setSelectedTab(newValue)
    setSubmitData((prevData) => ({ ...prevData, login: null, password: null }))
  }

  const handleCountrySelect = (countryCode) => {
    setSubmitData((prevData) => ({ ...prevData, login: null }))
    setCountrySelect((prev) => ({ 
      ...prev, 
      anchorEl: null,
      countryCode: countryCode,
      phoneCode:   countryCode === 'UZ' ? '+998' : '+7',
      phoneLength: countryCode === 'UZ' ? 9 : 10,
      placeholder: countryCode === 'UZ' ? '+998 _ _ - _ _ _ - _ _ _ _' : '+7 (_ _ _) _ _ _ - _ _ - _ _'
    }))
  }

  const redirect = async ({ server, login, secret }) => {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get('ref');

    if (ref == "acc") {
      // Если референс "ЛК УК" то ридеректим на лк ук с секретами
      window.location.href = `https://oico.app/acc/login?LOGIN_KEY_LOGIN=${login}&LOGIN_KEY=${secret}`;
    } else
    if (ref == "debt") {
        // Если референс "Проект по дебиторке" то ридеректим на проект дебиторки
        window.location.href = `https://ya.ds24.ru/debt/login?LOGIN_KEY_LOGIN=${login}&LOGIN_KEY=${secret}`;
    } else {
        // Иначе это д24 по умолчанию
        window.location.href = server + `cc/f?p=104:101:123::YES:101:P101_LOGIN_KEY_LOGIN,P101_LOGIN_KEY:${login},${secret}`;
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        bgcolor: '#EDEFF0'
      }}
    >
      <Card sx={{ display: 'flex', flexDirection: 'column', minWidth: { xs: 'auto', md: '38rem' }, p: { xs: 1.5, md: '2rem' } }}>
        <AppHeader />
        <Tabs onChange={(e, newValue) => handleTabChange(newValue)} value={selectedTab} sx={{...styled('tabs', 'sx'), my: 3.5 }}>
          <Tab value={"phone"} label='По телефону' />
          <Tab value={"login"} label='По логину' />
        </Tabs>

        <form onSubmit={postSignin}>
        <Grid container gap={3}>
          <Grid item xs={12} >
            <Grid container item spacing={3}>
              {selectedTab === 'phone'? (
                <Grid xs={12} item display='flex' direction='column' gap={0.5}>
                  <Typography fontSize={14} sx={{ color: theme.palette.grey.main }}>Телефон *</Typography>
                  <Grid container spacing={1} sx={{ flexDirection: 'row' }}>
                    <Grid item xs={2}>
                      <TextField fullWidth size="small"      
                        disabled={isLoading}
                        onClick={(e) => setCountrySelect((prev) => ({ ...prev, anchorEl: e.currentTarget }))}
                        sx={{ ...styled('autocomplete',"input", "filled"), '& .MuiInputBase-input': { cursor: 'pointer' } }}         
                        InputProps={{
                          readOnly: true,
                          startAdornment: 
                            <Box sx={{ display: 'flex', alignItems: 'center', ml: { xs: 0.2, sm: 1.5 } }}>
                              {countrySelect.countryCode == 'UZ' 
                                ? <UzbekistanIcon sx={{ width: 24, height: 18 }} /> 
                                : <RussiaIcon sx={{ width: 24, height: 18 }} />
                              }
                            </Box>,
                          endAdornment: <ExpandMore sx={{ color: 'grey.500', mr: { xs: 0.2, sm: 1 } }} />,
                        }}
                      />
                      <Menu
                        open={openCountrySelect}
                        anchorEl={countrySelect.anchorEl}
                        onClose={() => setCountrySelect((prev) => ({ ...prev, anchorEl: null }))}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        disableAutoFocusItem
                        sx={{...styled('menu', 'sx'),  '& .MuiList-root': { gap: 1 }}}
                        slotProps={styled('menu', 'slotProps')}
                      >
                        <MenuItem selected={countrySelect.countryCode === 'RU'} onClick={() => handleCountrySelect('RU')}>
                          <Box sx={{ display: 'flex',  gap: 1 }}>
                            <RussiaIcon />
                            <Typography fontSize={14}>Россия</Typography>
                          </Box>
                        </MenuItem>
                        <MenuItem onClick={() => handleCountrySelect('UZ')}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <UzbekistanIcon />
                            <Typography fontSize={14}>Узбекистан</Typography>
                          </Box>
                        </MenuItem>
                      </Menu>
                    </Grid>
                    <Grid item xs={10}>
                      <TextField fullWidth size="small"      
                        disabled={isLoading} 
                        value={
                          (() => {
                            let phone = submitData.login ?? '';
                            const phoneCode = countrySelect.phoneCode;
                            const countryCode = countrySelect.countryCode || 'RU';
                            const phoneLength = countrySelect.phoneLength;

                            return formatPhoneNumber(phone, phoneCode, countryCode, phoneLength);
                          })()
                        }
                        onChange={(e) => {
                          maskPhoneInput(
                            e.target.value,
                            countrySelect.phoneCode || '+7',
                            countrySelect.phoneLength || 10,
                            (formattedPhone) => {
                              setSubmitData((prevData) => ({ ...prevData, login: formattedPhone }));
                            }
                          );
                        }}
                        sx={{ ...styled('autocomplete',"input", "filled") }}         
                        placeholder={countrySelect.placeholder} 
                      />
                    </Grid>
                  </Grid>
                </Grid>        
              ) : (
                  <Grid xs={12} item display='flex' direction='column' gap={0.5}>
                  <Typography fontSize={14} sx={{ color: theme.palette.grey.main }}>Логин или почта *</Typography>
                  <TextField fullWidth size="small"      
                    value={submitData.login ?? ''}
                    disabled={isLoading}
                    onChange={(e) => { setSubmitData((prevData) => ({ ...prevData, login: e.target.value }))}}
                    sx={{ ...styled('autocomplete',"input", "filled") }}         
                    placeholder="Введите логин или почту" 
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} >
            <Grid container item spacing={3}>
              <Grid xs={12} item display='flex' direction='column' gap={0.5}>
                <Typography fontSize={14} sx={{ color: theme.palette.grey.main }}>Пароль *</Typography>
                <TextField fullWidth size="small" 
                  type={showPassword ? 'text' : 'password'}      
                  value={submitData.password ?? ''}
                  disabled={isLoading}
                  onChange={(e) => { setSubmitData((prevData) => ({ ...prevData, password: e.target.value }))}}
                  sx={{ ...styled('autocomplete',"input", "filled") }}   
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        <Tooltip placement='top' title={showPassword ? 'Скрыть пароль' : 'Показать пароль'}>
                          <IconButton
                            sx={{ opacity: submitData.password ? 1 : 0, transition: 'opacity 0.3s ease', pointerEvents: submitData.password ? 'auto' : 'none' }}
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            size="small"
                          >
                            {showPassword ? <VisibilityOffOutlined sx={{ fill: theme.palette.grey.main }} /> : <VisibilityOutlined sx={{ fill: theme.palette.grey.main }} />}
                          </IconButton>
                        </Tooltip>
                        </InputAdornment>  
                    ),
                  }}      
                  placeholder="Введите пароль" 
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid sx={{ display: 'flex', gap: 1.5, pt: 1 }}>
            
            <Button disabled={
                isLoading 
                || (!submitData.login || !submitData.login.trim())
                || (!submitData.password || !submitData.password.trim())
                } 
                type="submit"
                // onClick={() => postSignin()} 
                sx={{ ...styled('button',"secondary") }} 
                disableElevation
                variant="contained" 
                color={"green"}
              >
                {isLoading && <Box  sx={{ alignItems: 'center', display: 'flex' }} pr={1}><CircularProgress size={15} color='inherit' /></Box>}
                Войти
            </Button>
            <Button onClick={() => navigate('/recovery')} disabled={isLoading} sx={{ ...styled('button',"secondary") }} color='grey' variant="outlined">Забыли пароль?</Button>
          </Grid>  

        </Grid>
        {message && (
          <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pt: 2 }}>
            <WarningAmber sx={{ fill: theme.palette.error.main, cursor: 'auto' }} />
            <Typography sx={{ color: theme.palette.error.main, fontSize: 14 }}>{message}</Typography>
          </Grid>
        )}
        {messageText && (
           <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pt: 2 }}>
            <InfoSharp sx={{ color: theme.palette.success.main, cursor: 'auto' }} />
            <Typography sx={{ color:theme.palette.success.main, fontSize: 14 }}>{messageText}</Typography>
          </Grid>
        )}
        </form>

        <Grid sx={{ pt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.2, md: 1 } }}>
            <AskChatIcon style={{ cursor: 'default' }} />
            <Typography sx={{ color: theme.palette.grey.main, fontSize: 14, pl: 1 }}>Возникли проблемы?</Typography>
            <Typography onClick={() => setModalSupport(true)} sx={{ color: theme.palette.blue, fontSize: 14, cursor: 'pointer' }}>Служба поддержки</Typography>
          </Grid>
          <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SmartphoneOutlined  style={{ cursor: 'default', fill: theme.palette.grey.main }} />
            <Typography onClick={() => setModalQR(true)} sx={{ color: theme.palette.blue, fontSize: 14, pl: 1, cursor: 'pointer' }}>Скачать приложение</Typography>
          </Grid>        
        </Grid> 

        <ModalDownloadAppQR open={modalQR}      onClose={() => setModalQR(false)} />    
        <ModalSupport       open={modalSupport} onClose={() => setModalSupport(false)} />    
      </Card>
    </Box>
  )
}

export default Login
